import { AdminApiError } from "./errors";

export function handleApiError<T>(error: unknown, context: string, fallback?: T): T {
  if (error instanceof AdminApiError) {
    console.error(`[${context}]`, error.message, { status: error.status, payload: error.data });
  } else {
    console.error(`[${context}]`, error);
  }

  if (fallback !== undefined) {
    return fallback;
  }

  throw error instanceof Error ? error : new Error(context);
}
